<div
  [ngClass]="{
    planItem: true,
    'planItem--free': plan === 'free',
    'planItem--pro': plan === 'plus',
    'planItem--entp': plan === 'pro',
  }"
>
  <ng-container [ngSwitch]="plan">
    <!-- Free Plan -->
    <ng-container *ngSwitchCase="'free'">
      <ddc-text-gradient class="dashboard-header-txt dashboard-title text-3xl" [_text]="'Free'" [_type]="'2'">
      </ddc-text-gradient>
      <div class="card__desc">Free plan to play around and experience the features of daydic.</div>
      <div class="price">€0<span>/ month</span></div>
      <ul class="featureList">
        <li>50 Words</li>
        <li>25 Pairs</li>
        <li>3 Categories</li>
        <li>3 Tags</li>
        <li>3 Bookmarks</li>
        <li>3 Collections</li>
        <li>1 Dictionary</li>
        <li>1 Note</li>
        <li>1 Quiz</li>
        <li>1 Figure</li>
        <li class="disabled"><span>Flash cards</span> <mat-icon class="material-icons-outlined">bolt</mat-icon></li>
        <li class="disabled">
          <span>Matching game</span><mat-icon class="material-icons-outlined">sports_esports</mat-icon>
        </li>
        <li class="disabled">
          <span>Practice weak points</span><mat-icon class="material-icons-outlined">fitness_center</mat-icon>
        </li>
        <li class="disabled">
          <span>Export dictionaries as PDF</span> <mat-icon class="material-icons-outlined">print</mat-icon>
        </li>
        <li class="disabled">
          <span>Daydic Group (Study Together)</span> <mat-icon class="material-icons-outlined">group</mat-icon>
        </li>
        <li class="disabled"><span>Daydic Travel</span> <mat-icon class="material-icons-outlined">flight</mat-icon></li>
        <li class="disabled">
          <span>Daydic Academy</span> <mat-icon class="material-icons-outlined">school</mat-icon>
        </li>
        <li class="disabled"><span>Daydic Love</span> <mat-icon class="material-icons-outlined">favorite</mat-icon></li>
        <li class="disabled">
          <span>Daydic Licenses (e.g. Driving License)</span> <mat-icon class="material-icons-outlined">badge</mat-icon>
        </li>
        <li class="disabled">
          <span>Full Access to Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Create Dictionaries by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Dictionary Suggestions by Lingo AI</span>
          <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Create Notes by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Create Quizzes by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Create Figures by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Improve Your Content by Lingo AI</span>
          <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
      </ul>
    </ng-container>
    <!-- Plus Plan -->
    <ng-container *ngSwitchCase="'plus'">
      <div class="flex flex-col items-center">
        <ddc-text-gradient class="dashboard-header-txt dashboard-title text-3xl" [_text]="'Plus'" [_type]="'2'">
        </ddc-text-gradient>
        <span
          class="bg-purple-100 text-gray-800 text-xs font-medium mt-2 me-2 px-2.5 py-0.5 rounded-full dark:bg-gray-900 dark:text-gray-300"
          >I M P R O V E D</span
        >
      </div>
      <div class="card__desc">
        Unlock more features for serious learners, including PDF export and some Daydic exclusive features.
      </div>
      <div class="price">€34.99<span>/ year (only 2.9€ / month)</span></div>
      <ul class="featureList">
        <li>Unlimited Words, Pairs and Dictionaries</li>
        <li>Unlimited Categories and Tags</li>
        <li>Flash cards and Matching games</li>
        <li>Practice weak points</li>
        <li>10 Notes <mat-icon class="material-icons-outlined">notes</mat-icon></li>
        <li>3 Quizzes <mat-icon class="material-icons-outlined">quiz</mat-icon></li>
        <li>3 Figures <mat-icon class="material-icons-outlined">image</mat-icon></li>
        <li><span>Export dictionaries as PDF</span> <mat-icon class="material-icons-outlined">print</mat-icon></li>
        <li><span>Daydic Group (Study Together)</span> <mat-icon class="material-icons-outlined">group</mat-icon></li>
        <li><span>Daydic Travel</span> <mat-icon class="material-icons-outlined">flight</mat-icon></li>
        <li><span>Daydic Academy</span> <mat-icon class="material-icons-outlined">school</mat-icon></li>
        <li><span>Daydic Love</span> <mat-icon class="material-icons-outlined">favorite</mat-icon></li>
        <li>
          <span>Daydic Licenses (e.g. Driving License)</span> <mat-icon class="material-icons-outlined">badge</mat-icon>
        </li>
        <li>
          <span>Limited Access to Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Full Access to Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Create Dictionaries by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Dictionary Suggestions by Lingo AI</span>
          <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Create Notes by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Create Quizzes by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Create Figures by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li class="disabled">
          <span>Improve Your Content by Lingo AI</span>
          <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
      </ul>
      @if (!infoOnly) {
        <button
          class="get_started_btn"
          color="primary"
          mat-flat-button
          (click)="toBillingPage && toBillingPage('plus')"
        >
          Get Started
        </button>
      }
    </ng-container>
    <!-- Pro Plan -->
    <ng-container *ngSwitchCase="'pro'">
      <div class="flex flex-col items-center">
        <ddc-text-gradient
          class="dashboard-header-txt dashboard-title text-3xl"
          [_text]="'Pro'"
          [_type]="'1'"
        ></ddc-text-gradient>
        <span
          class="bg-purple-100 text-gray-800 text-xs font-medium mt-2 me-2 px-2.5 py-0.5 rounded-full dark:bg-gray-900 dark:text-gray-300"
          >B E S T - V A L U E</span
        >
      </div>
      <div class="card__desc">
        Unlock all advanced features, ALL-IN-ONE package including Lingo our AI Agent. Save MASSIVE time and effort...
        Lingo AI got you covered :)
      </div>
      <div class="price">€89.99<span>/ year (only 7.49€ / month)</span></div>
      <ul class="featureList">
        <li>Unlimited Words, Pairs and Dictionaries</li>
        <li>Unlimited Categories and Tags</li>
        <li>Flash cards and Matching games</li>
        <li>Practice weak points</li>
        <li>Unlimited Notes <mat-icon class="material-icons-outlined">notes</mat-icon></li>
        <li>Unlimited Quizzes <mat-icon class="material-icons-outlined">quiz</mat-icon></li>
        <li>Unlimited Figures <mat-icon class="material-icons-outlined">image</mat-icon></li>
        <li><span>Export dictionaries as PDF</span> <mat-icon class="material-icons-outlined">print</mat-icon></li>
        <li><span>Daydic Group (Study Together)</span> <mat-icon class="material-icons-outlined">group</mat-icon></li>
        <li><span>Daydic Travel</span> <mat-icon class="material-icons-outlined">flight</mat-icon></li>
        <li><span>Daydic Academy</span> <mat-icon class="material-icons-outlined">school</mat-icon></li>
        <li><span>Daydic Love</span> <mat-icon class="material-icons-outlined">favorite</mat-icon></li>
        <li>
          <span>Daydic Licenses (e.g. Driving License)</span> <mat-icon class="material-icons-outlined">badge</mat-icon>
        </li>
        <li><span>Full Access to Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon></li>
        <li>
          <span>Create Dictionaries by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li>
          <span>Dictionary Suggestions by Lingo AI</span>
          <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li><span>Create Notes by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon></li>
        <li>
          <span>Create Quizzes by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li>
          <span>Create Figures by Lingo AI</span> <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
        <li>
          <span>Improve Your Content by Lingo AI</span>
          <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
        </li>
      </ul>
      @if (!infoOnly) {
        <!-- <a
          class="get_started_btn"
          color="primary"
          href="https://apps.apple.com/de/app/daydic/id1531175789?l=en-GB"
          mat-flat-button
          rel="noopener noreferrer"
          target="_blank"
        >
          Upgrade with iOS In-App Purchase
        </a> -->
        <button class="get_started_btn" color="primary" mat-flat-button (click)="toBillingPage && toBillingPage('pro')">
          Learn like a Pro!
        </button>
      }
    </ng-container>
  </ng-container>
</div>
